/**
 * @voltxampere/ui — HC-SR04 ultrasonic distance sensor variant (Sprint 48-8)
 *
 * Sprint 48-8 — New ultrasonic distance sensor. Non-bus, GPIO-based
 * timing protocol. Trigger pulse 10 µs HIGH on TRIG pin → module
 * sends 8 cycles of 40 kHz ultrasonic burst → ECHO pin goes HIGH for
 * the duration corresponding to round-trip distance (58 µs/cm).
 *
 * Sensor activation layer drives:
 *   - TRIG: GPIO output, 10 µs HIGH pulse to start measurement
 *   - ECHO: GPIO input, HIGH duration encodes distance
 *
 * Range: 2-400 cm. Resolution 0.3 cm. Power: 5 V (TTL).
 *
 * Sentinel-friendly: GPIO timing measurement → AVR emulator uses
 * Timer1 input capture (Sprint 51+) or polling on PINx state.
 *
 * Reference: ELEC Freaks HC-SR04 datasheet (HiletGo / generic clone).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (analog 5V rail; TRIG/ECHO digital lines wired separately).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorHcSr04 = {
    id: "hc-sr04",
    nameTr: "HC-SR04 (Ultrasonic Mesafe Sensörü)",
    nameEn: "HC-SR04 (Ultrasonic Distance Sensor)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "HC-SR04",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 5.0,
        triggerPulseUs: 10,
        distancePerEchoUs: 1 / 58, // 1 cm = 58 µs round-trip
        rangeCm: { min: 2, max: 400 },
        resolutionCm: 0.3,
        burstFrequencyHz: 40_000,
        busType: "gpio-timing",
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-hc-sr04.js.map